import { Directive, ElementRef, inject, Input, OnChanges, Renderer2 } from "@angular/core";

@Directive({
  selector: "[AsteriskMessage]",
  standalone: false,
})
export class AsteriskMessageDirective implements OnChanges {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);

  constructor() {}

  ngOnChanges() {
    const asterisk = this.el.nativeElement;
    asterisk.innerHTML = "";
    if (!this.messageList.length) return;
    const outerDiv = this.createElement("div", "asterisk-message-outer", "");
    this.renderer.setAttribute(outerDiv, "id", this.containerID);
    this.renderer.appendChild(outerDiv, this.createElement("span", "asterisk-alert text-error fw-bold", "*Error Messages"));
    this.renderer.appendChild(asterisk, outerDiv);
    this.renderer.appendChild(asterisk, this.createElement("div", "row m-0 px-3 pb-3 border-error asterisk-container border-radius-10", ""));
    const row = asterisk.lastElementChild as HTMLElement;
    this.messageList.forEach(element => {
      const div = this.createElement("div", "col-xxl-4 col-lg-4 col-md-6 col-12 mt-3 --text-red", "* ");
      const span = this.createElement("span", "asterisk-message text-error", element);
      this.renderer.appendChild(div, span);
      this.renderer.appendChild(row, div);
    });
    document.getElementById(this.containerID)?.scrollIntoView({ behavior: "smooth" });
  }

  /**
   * It will accept the input of error messages. Ex : ['Number Required', 'Name Required']
   */
  @Input() messageList: string[] = [];

  /**
   * It will accept the ID of error container. Because on detect error it will scroll on top of the container
   */
  @Input() containerID: string = "ErrorMessage";

  createElement(tag: string, className: string, value: string) {
    const element = this.renderer.createElement(tag);
    const text = this.renderer.createText(value);
    const classList = className?.split(" ");
    classList.forEach(item => {
      this.renderer.addClass(element, item);
    });
    value && this.renderer.appendChild(element, text);
    return element;
  }
}
